
import { FC, useEffect, useState, useRef } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTIcon, QUERIES } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteUser, updateUser, createUser } from '../../core/_requests'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { AssignHubModal } from './AssignPickUPBoy'
import GenerateQrCode from './GenerateQrCode'
import { useLocation, useNavigate } from 'react-router-dom'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { UserConfirmationDelete } from './UserDeleteConfirmation'
import { MapImageModal } from './MapImageModal'
import { IssueCouponModal } from './IssueCouponModal'
import { BeneficirariesModal } from './Beneficiraries'
import { useAuth } from '../../../../../auth'
import { ViewModal } from './ViewModal'
import DetailedViewCollectOrder from './DetailedViewCollectOrder'
type Props = {
  id: any
  allData: any
  action: any
}

const UserActionsCell: FC<Props> = ({ id, allData, action = ['edit'] }) => {
  const contentRef = useRef(null)
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()
  const { state } = useQueryRequest()
  const [showPickUpModal, setShowAssignHubModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState<any>(false)
  const { pathname } = useLocation()
  const [showMapModal, setShowMapModal] = useState(false)
  const [showCouponModal, setShowCouponModal] = useState(false)
  const [showBeneficirariesModall, setBeneficirariesModal] = useState(false)
  const [showViewModal, setShowViewModal] = useState(false)

  const {
    auth,
    isAdmin,
    isAuditor,
    isFacilityManager,
    isSupplyChainManager,
    isFranchise,
    isPartner,
    isSponsor,
    currentUser,
  }: any = useAuth()
  const isMarketingUser = currentUser?.userType === 'CLIENT_USER' || currentUser?.userType === 'MARKETING'

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = (payload?: any) => {
    if (payload && Object.keys(payload)?.length > 0) setItemIdForUpdate({ ...id, ...payload })
    else setItemIdForUpdate(id)
  }
  const assignPostMethod = useMutation(
    (payload: any) => createUser(payload, `smart-centre/order/assign-agent`),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`return123/orders-${query}`])
        setShowAssignHubModal(false)
      },
    }
  )
  const deleteItem = useMutation(() => updateUser(id, `categories/${id.id}/update`), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
    },
  })

  const showAssignHubModal = () => {
    setShowAssignHubModal(true)
  }

  // const toggleStatus = useMutation(
  //   () =>
  //     updateUser(
  //       {},
  //       `user/${id.id}/status?type=${state.type}&status=${id.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
  //       }`
  //     ),
  //   {
  //     // 💡 response of the mutation is passed to onSuccess
  //     onSuccess: () => {
  //       // ✅ update detail view directly
  //       queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
  //       successToast(
  //         `The selected franchisee access has been ${id.status === 'ACTIVE' ? 'disbaled' : 'enabled'
  //         }`
  //       )
  //     },
  //   }
  // )

  const toggleStatus = useMutation(
    (newStatus: string) =>
      updateUser(
        {},
        pathname.includes('/apps/settings/items')
          ? `items/${id.id}/updateStatus?status=${newStatus}`
          : pathname.includes('/apps/settings/processing-routes')
            ? `materialProcess/${id.id}/updateStatus?status=${newStatus}`
            : pathname.includes('/apps/settings/category')
              ? `categories/${id.id}/updateStatus?status=${newStatus}`
              : `user/${id.id}/status?type=${state.type}&status=${newStatus}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
        successToast('Status updated successfully')
      },
    }
  )

  const [showQrCode, setShowQrCode] = useState(false)
  const [showDetailedView, setShowDetailedView] = useState(false)
  const navigate = useNavigate()
  if (showMapModal) {
    return <MapImageModal close={() => setShowMapModal(false)} data={id} name={'Map'} />
  }
  return (
    <>
      {/* {(action.includes('details') && (
        <a
          onClick={() =>
            pathname.includes('apps/leaderboard')
              ? navigate(`/apps/leaderboard/details/${id.pickupPointId}`)
              : navigate(`/apps/plastic-credits/details/${id.productionId}`)
          }
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        >
          <KTIcon iconName='code' className='fs-3' />
        </a>
      )) ||
        false} */}

      <div className='d-flex align-items-center justify-content-center gap-1'>
        {/* {(action.includes('details') && (
          <a
            onClick={() =>
              pathname.includes('apps/leaderboard')
                ? navigate(`/apps/leaderboard/details/${id.pickupPointId}`)
                : navigate(`/apps/plastic-credits/details/${id.productionId}`)
            }
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='code' className='fs-3' />
          </a>
        )) ||
          false} */}

        {/* {(action.includes('details') && (

          <a
            onClick={() =>
              pathname.includes('apps/leaderboard')
                ? navigate(`/apps/leaderboard/details/${id.pickupPointId}`)
                : pathname.includes('apps/facility/user-information')
                  ? navigate(`/apps/facility/user-information/${id.id}`)
                  : navigate(`/apps/plastic-credits/details/${id.productionId}`)
            }
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='code' className='fs-3' />
          </a>
        )) ||
          false} */}

        {/* {(action.includes('details') && (
          pathname.includes('apps/facility/user-information') ? (

            <a
              onClick={() => navigate(`/apps/facility/user-information/${id.id}`)}
              style={{
                display: 'inline-block',
                padding: '6px 16px',
                backgroundColor: '#009ef7',
                color: '#ffffff',
                textDecoration: 'none',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500',
                borderRadius: '6px',
                border: 'none',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0077cc'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#009ef7'}
            >
              View
            </a>
          ) : (

            <a onClick={() =>
              pathname.includes('apps/leaderboard')
                ? navigate(`/apps/leaderboard/details/${id.pickupPointId}`)
                : pathname.includes('apps/facility/user-information')
                  ? navigate(`/apps/facility/user-information/${id.id}`)
                  : navigate(`/apps/plastic-credits/details/${id.productionId}`)
            }
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='code' className='fs-3' />
            </a >
          )
        )) || false} */}

        {pathname.includes('/apps/waste-source/waste-collector') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                {!isMarketingUser && (
                  <a
                    className='dropdown-item'
                    onClick={() => {
                      openEditModal()
                    }}
                    style={{
                      padding: '8.45px 9.75px',
                      cursor: 'pointer',
                      fontSize: '12.35px',
                      color: '#5E6278',
                      fontWeight: '600',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                  >
                    Edit
                  </a>
                )}
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowQrCode(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  View QR
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowViewModal(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  View
                </a>
              </li>
              {!isMarketingUser && (
                <li>
                  <a
                    className='dropdown-item'
                    onClick={() => setShowCouponModal(true)}
                    style={{
                      padding: '8.45px 9.75px',
                      cursor: 'pointer',
                      fontSize: '12.35px',
                      color: '#5E6278',
                      fontWeight: '600',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                  >
                    Issue coupon
                  </a>
                </li>
              )}
            </ul>
          </div>
        )}

        {showViewModal && (
          <ViewModal id={id} data={allData} close={() => setShowViewModal(false)} />
        )}

        {pathname.includes('/apps/transactions/supply-orders') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
              {/* <svg style={{ width: '0.75rem', height: '0.75rem', margin: '0' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg> */}
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowDetailedView(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Detailed view
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => openEditModal({ showCertificate: true })}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Receipt
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowQrCode(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Batch QR
                </a>
              </li>
            </ul>
          </div>
        )}

        {pathname.includes('/apps/settings/coupons-1') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              {/* <li>
                <a className='dropdown-item'
                  onClick={() => openEditModal({ showCertificate: true, showProductionReceipt: true })}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  Edit
                </a>
              </li> */}
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setBeneficirariesModal(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Beneficiraries
                </a>
              </li>
            </ul>
          </div>
        )}

        {pathname.includes('/apps/transactions/processing-record') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
              {/* <svg style={{ width: '0.75rem', height: '0.75rem', margin: '0' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg> */}
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                <a
                  className='dropdown-item'
                  onClick={() =>
                    openEditModal({ showCertificate: true, showProductionReceipt: true })
                  }
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Receipt
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowQrCode(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Batch QR
                </a>
              </li>
            </ul>
          </div>
        )}

        {pathname.includes('/apps/transactions/collect-orders') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
              {/* <svg style={{ width: '0.75rem', height: '0.75rem', margin: '0' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg> */}
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowDetailedView(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Detailed view
                </a>
              </li>
              <li>
                {!isSupplyChainManager && <a
                  className='dropdown-item'
                  onClick={() => {
                    if (
                      pathname.includes('apps/transactions/collect-orders') &&
                      !['approval_pending'].includes(allData.status.toLowerCase())
                    ) {
                      return false
                    }
                    openEditModal()
                  }}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: !['approval_pending'].includes(allData.status.toLowerCase())
                      ? 'not-allowed'
                      : 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                    opacity: !['approval_pending'].includes(allData.status.toLowerCase()) ? 0.2 : 1,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Approve
                </a>}
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => openEditModal({ showCertificate: true })}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Receipt
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => setShowQrCode(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Batch QR
                </a>
              </li>
            </ul>
          </div>
        )}

        {/* {pathname.includes('/apps/business-development/fullfilment') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => openEditModal()}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Assign Hub
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() =>
                    navigate('/apps/business-development/fullfilment/status', {
                      state: {id: id.sponsorId, data1: allData},
                    })
                  }
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  View
                </a>
              </li>
            </ul>
          </div>
        )} */}

        {pathname.includes('/apps/business-development/fullfilment') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>

                <a className='dropdown-item'
                  onClick={() => {
                    if (id.status !== 'COMPLETED') {
                      openEditModal()
                    }
                  }}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: id.status === 'COMPLETED' ? 'not-allowed' : 'pointer',
                    fontSize: '12.35px',
                    color: id.status === 'COMPLETED' ? '#A1A5B7' : '#5E6278',
                    fontWeight: '600',
                    opacity: id.status === 'COMPLETED' ? 0.6 : 1,
                  }}
                  onMouseEnter={(e) => {
                    if (id.status !== 'COMPLETED') {
                      e.currentTarget.style.backgroundColor = '#F9FAFB'
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (id.status !== 'COMPLETED') {
                      e.currentTarget.style.backgroundColor = 'transparent'
                    }
                  }}
                >
                  Assign hub
                </a>
              </li>
              <li>

                <a className='dropdown-item'
                  onClick={() =>
                    navigate('/apps/business-development/fullfilment/status', {
                      state: { id: id.sponsorId, data1: allData },
                    })
                  }
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  View
                </a>
              </li>
            </ul>
          </div >
        )}

        {pathname.includes('/apps/transactions/items') && (
          <div className='btn-group'>
            <button
              type='button'
              className='dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                textAlign: 'center',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                border: '0',
                padding: '0.55rem 0.75rem',
                fontSize: '1rem',
                lineHeight: '1.5',
                borderRadius: '0.475rem',
                transition:
                  'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out',
                color: '#5e6278',
                backgroundColor: '#f5f8fa',
                gap: '0.5rem',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = '#009ef7'
                e.currentTarget.style.backgroundColor = '#f1faff'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = '#5e6278'
                e.currentTarget.style.backgroundColor = '#f5f8fa'
              }}
            >
              Actions
              {/* <svg style={{ width: '0.75rem', height: '0.75rem', margin: '0' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg> */}
            </button>
            <ul
              className='dropdown-menu'
              style={{
                backgroundColor: '#ffffff',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                minWidth: '100px',
                padding: '4px 0',
              }}
            >
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => {
                    if (
                      pathname.includes('apps/transactions/collect-orders') &&
                      !['approval_pending'].includes(allData.status.toLowerCase())
                    ) {
                      return false
                    }
                    openEditModal()
                  }}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: !['approval_pending'].includes(allData.status.toLowerCase())
                      ? 'not-allowed'
                      : 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                    opacity: !['approval_pending'].includes(allData.status.toLowerCase()) ? 0.2 : 1,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  edit
                </a>
              </li>
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => openEditModal({ showCertificate: true })}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Receipt
                </a>
              </li>
              {/* <li>
                <a className='dropdown-item'
                  onClick={() => setShowQrCode(true)}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  Batch QR
                </a>
              </li> */}
              <li>
                <a
                  className='dropdown-item'
                  onClick={() => openEditModal({ showCertificate: false })}
                  style={{
                    padding: '8.45px 9.75px',
                    cursor: 'pointer',
                    fontSize: '12.35px',
                    color: '#5E6278',
                    fontWeight: '600',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  Mark as delivered
                </a>
              </li>
            </ul>
          </div>
        )}

        {(action.includes('details') &&
          (pathname.includes('apps/facility/user-information') ? (
            <a
              onClick={() => navigate(`/apps/facility/user-information/${id.id}`)}
              style={{
                display: 'inline-block',
                padding: '6px 16px',
                backgroundColor: '#009ef7',
                color: '#ffffff',
                textDecoration: 'none',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500',
                borderRadius: '6px',
                border: 'none',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#0077cc')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#009ef7')}
            >
              View
            </a>
          ) : (
            <a
              onClick={() =>
                pathname.includes('apps/leaderboard')
                  ? navigate(`/apps/leaderboard/details/${id.pickupPointId}`)
                  : pathname.includes('apps/facility/user-information')
                    ? navigate(`/apps/facility/user-information/${id.id}`)
                    : pathname.includes('/apps/client')
                      ? navigate(`/apps/client/details/${id.id}`, {
                        state: { clientData: id },
                      })
                      : navigate(`/apps/plastic-credits/details/${id.productionId}`)
              }
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='code' className='fs-3' />
            </a>
          ))) ||
          false}

        {showCouponModal && (
          <IssueCouponModal id={id} data={allData} close={() => setShowCouponModal(false)} />
        )}

        {showBeneficirariesModall && (
          <BeneficirariesModal id={id} data={allData} close={() => setBeneficirariesModal(false)} />
        )}

        {showViewModal && (
          <ViewModal id={id} data={allData} close={() => setShowViewModal(false)} />
        )}

        {(action.includes('view_prod_certificate') && (
          <a
            onClick={() => openEditModal({ showCertificate: true, showProductionReceipt: true })}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='eye' className='fs-3' />
          </a>
        )) ||
          false}
        {(action.includes('certificate') && (
          <a
            onClick={() => openEditModal({ showCertificate: true })}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='eye' className='fs-3' />
          </a>
        )) ||
          false}
        {((action.includes('view_certificate') || action.includes('view-table')) && (
          <a
            onClick={() => openEditModal({ showTable: true })}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='eye' className='fs-3' />
          </a>
        )) ||
          false}
        {showPickUpModal && (
          <AssignHubModal
            id={id}
            confirm={async (payload) => await assignPostMethod.mutateAsync(payload)}
            close={() => setShowAssignHubModal(false)}
          />
        )}
        {showQrCode && (
          <GenerateQrCode action={action} data={id} close={() => setShowQrCode(false)} />
        )}
        {showDetailedView && (
          <DetailedViewCollectOrder data={id} close={() => setShowDetailedView(false)} showDetailedView={showDetailedView} />
        )}
        <div className='align-items-center'>
          {(action.includes('map') && (
            <div onClick={() => setShowMapModal(true)} className=''>
              Click to view
            </div>
          )) ||
            false}
          {(action.includes('view') && (
            <a
              onClick={() =>
                pathname.includes('unaudited') ||
                  pathname.includes('audited') ||
                  pathname.includes('transactions/items') ||
                  pathname.includes('retired') ||
                  pathname.includes('apps/transactions/collect-orders')
                  ? openEditModal({ showCertificate: true })
                  : openEditModal(true)
              }
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='eye' className='fs-3' />
            </a>
          )) ||
            false}

          {/* {(action.includes('download') && (
          <>
            <a
              onClick={() => handleDownload()}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='file-down' className='fs-3' />
            </a>
          </>
        )) ||
          false} */}

          {(action.includes('edit') && (
            <a
              onClick={() => {
                if (
                  pathname.includes('apps/transactions/collect-orders') &&
                  !['approval_pending'].includes(allData.status.toLowerCase())
                ) {
                  return false
                } else if (
                  pathname.includes('apps/transactions/items') &&
                  ['completed', 'pickup completed'].includes(allData.status.toLowerCase())
                ) {
                  return false // Prevents click action
                }
                else if (
                  pathname.includes('apps/business-development/My-Portfolio') &&
                  ['completed'].includes(allData.status.toLowerCase())
                ) {
                  return false
                }
                openEditModal()
              }}
              style={{
                opacity: pathname.includes('apps/transactions/collect-orders')
                  ? !['approval_pending'].includes(allData.status.toLowerCase())
                    ? 0.2
                    : 1
                  : pathname.includes('apps/transactions/items') &&
                    ['completed', 'pickup completed'].includes(allData.status.toLowerCase())
                    ? 0.2
                    : 1,
                cursor:
                  pathname.includes('apps/transactions/items') &&
                    ['completed', 'pickup completed'].includes(allData.status.toLowerCase())
                    ? 'not-allowed'
                    : 'pointer',
              }}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
          )) ||
            false}

          {action.includes('assign') && (
            <>
              {id.status && id.status === 'Pickup Assigned' ? (
                '-----'
              ) : (
                <a
                  onClick={async () =>
                    allData.status &&
                      ['completed', 'pickup completed'].includes(allData.status.toLowerCase())
                      ? ''
                      : showAssignHubModal()
                  }
                  style={{
                    cursor:
                      allData.status &&
                      ['completed', 'pickup completed'].includes(allData.status.toLowerCase()) &&
                      'not-allowed',
                  }}
                >
                  Assign rider
                </a>
              )}
            </>
          )}
          {/* {action.includes('delete') && action.includes('edit') && (
          <a
            // onClick={async () => await deleteItem.mutateAsync()}
            onClick={() => setShowDeleteModal(!showDeleteModal)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          >
            <KTIcon iconName='trash' className='fs-3' />
          </a>
        )} */}

          {/* {action.includes('delete') && action.includes('edit') && (
          <a
            onClick={() => setShowDeleteModal(!showDeleteModal)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          >
            <KTIcon iconName='trash'
              className={`fs-3 ${pathname.includes('/apps/settings/product-testing') ? 'text-danger' : ''}`}
            />
          </a>
        )} */}

          {action.includes('delete') &&
            action.includes('edit') &&
            (!pathname.includes('/apps/waste-source/waste-collector') ||
              allData.totalDepositedQuantity === 0) && (
              <a
                onClick={() => setShowDeleteModal(!showDeleteModal)}
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
              >
                <KTIcon iconName='trash' className='fs-3 text-danger' />
              </a>
            )}

          {showDeleteModal && (
            <UserConfirmationDelete data={id} close={() => setShowDeleteModal(false)} />
          )}
          {(action.includes('toggle') && (
            <div className="btn btn-icon btn-active-color-primary">
              <div className="form-switch">
                <input
                  style={{ backgroundColor: '#12B886' }}
                  className="form-check-input"
                  type="checkbox"
                  id="allowmarketing"
                  checked={id.status === 'ACTIVE'}
                  onChange={async (e) => {
                    const newStatus = e.target.checked ? 'ACTIVE' : 'INACTIVE'
                    await toggleStatus.mutateAsync(newStatus)
                  }}
                />
              </div>
            </div>
          )) ||
            false}
          {/* {(action.includes('qr') &&
          (id.status === 'Accepted' ||
            id.status === 'ACTIVE' ||
            pathname.includes('collect-orders') ||
            pathname.includes('weight-scale')) && (
            <a
              onClick={() => setShowQrCode(true)}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='code' className='fs-3' />
            </a>
          )) ||
          false} */}
          {(action.includes('qr') &&
            (id.status === 'Accepted' ||
              id.status === 'ACTIVE' ||
              pathname.includes('collect-orders') ||
              pathname.includes('weight-scale') ||
              pathname.includes('processing-record') ||
              pathname.includes('supply-orders')) && (
              <a
                onClick={() => setShowQrCode(true)}
                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              >
                <KTIcon iconName='code' className='fs-3' />
              </a>
            )) ||
            false}

          {action.includes('qrr') && (
            <a
              onClick={() => setShowQrCode(true)}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='code' className='fs-3' />
            </a>
          )}
        </div>
        {(action.includes('product-details') && (
          <a
            onClick={() => setShowQrCode(true)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTIcon iconName='code' className='fs-3' />
          </a>
        )) ||
          false}
      </div>
      {/* <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            Edit
          </a>
        </div>

        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-kt-users-table-filter='delete_row'
            onClick={async () => await deleteItem.mutateAsync()}
          >
            Delete
          </a>
        </div>
      </div> */}
    </>
  )
}

export { UserActionsCell }
